import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }

import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import { TabItem } from '@/shared/components/pageHeader/tabItem';
import { ON_REPORT_VIEW_EXIT } from '@/store/reports/actionTypes';
import { RouteLocationNormalized, useRoute, useRouter } from 'vue-router';
import { NLP_ENABLED } from '@/store/app/featureTypes';
import ReportFilters from '@/features/reports/components/ReportFilters.vue';
import { useStore } from 'vuex';
import { computed, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Reports',
  setup(__props) {

const store = useStore();
const isWorkspaceFeatureEnabled = (feature: string) => computed(() => store.getters.isWorkspaceFeatureEnabled(feature));
const onReportExit = (from: string, to: string) => store.dispatch(ON_REPORT_VIEW_EXIT, { from, to });

const route = useRoute();
const router = useRouter();

watch(
  () => route.path,
  (newPath, oldPath) => {
    if (oldPath?.includes('/reports/')) {
      handleOnTabExit(route, { path: oldPath } as RouteLocationNormalized);
    }
  },
  { immediate: true },
);

//
const tabs = computed<TabItem[]>(() => {
  const tabs = [
    { name: 'Overview', route: 'reports-overview' },
    { name: 'Usage', route: 'reports-usage' },
    { name: 'Flows', route: 'reports-flows' },
  ];

  if (isWorkspaceFeatureEnabled(NLP_ENABLED).value) {
    tabs.push({ name: 'Intents', route: 'reports-intents' });
  }

  return tabs;
});

function handleOnTabExit(to: RouteLocationNormalized, from: RouteLocationNormalized) {
  const fromName = typeof from.name === 'string' ? from.name : String(from.name ?? '');
  const toName = typeof to.name === 'string' ? to.name : String(to.name ?? '');
  onReportExit(fromName, toName);
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader, {
      title: "Reports",
      description: "View your workspace's messaging trends",
      tabs: tabs.value
    }, {
      "tab-icons": _withCtx(() => [
        _createVNode(ReportFilters)
      ]),
      _: 1
    }, 8, ["tabs"]),
    _createVNode(_component_router_view)
  ]))
}
}

})